<!--
 * @Author: etong
 * @Date: 2021-06-30 14:15:22
 * @LastEditTime: 2023-03-20 17:06:25
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\components\JJForm\form.vue
 * Think first, Program later
-->
<template>
  <el-form
    ref="ruleForm"
    :model="value"
    v-bind="formConfig"
    class="jj-dynamic-form"
    label-position="right"
    label-width="100px"
  >
    <el-row :gutter="4" class="form-main-body-class">
      <el-col
        v-for="item in formConfig.formItemList"
        :key="item.key"
        :span="+item.span">
        <jj-form-item
          :jj-form-instance="this"
          :key="item.key"
          :item="item"
          v-bind="item"
          :item-ref="item.key"
          :value="value[item.key]"
          :is-allow="!formConfig['disabled']"
          :files="item.type==='file'?value[item.key]:''"
          :style="{'min-width':columnMinWidth}"
          @change="handleLinkChange($event, item)"
          @input="handleInput($event, item)"
          @excelTextCallBack="excelTextCallBack"
          @fileCallBack="fileCallBack"
          @fileListCallBack="fileListCallBack"
        />
      </el-col>
    </el-row>

    <slot></slot>
    <!-- <el-form-item>
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button>取消</el-button>
    </el-form-item> -->
  </el-form>
</template>

<script>
import request from '@/utils/request'
import Apis from '@/api/commonPage/commonForm'
import { optionsChain, number_format, deepClone } from '@/utils'
// import formChangeEvent from '@/utils/formChangeEvent.js'
import { handleLinkChangeEvent } from '@/utils/formChangeEvent.js'
import { cloneDeep } from 'lodash'
export default {
  name: 'JJForm',
  inject: ['lowcodeFormInstance'],
  props: {
    // 配置的json
    // 主样式 是否行内等
    // formItemList 表单配置列表
    formConfig: {
      type: Object,
      required: true
    },
    // 值的键值对
    value: {
      type: Object,
      required: true
    },
    // 明细行修改id 合集字符串
    delIds: {
      type: String,
      default: ''
    },
    // 最小的宽度
    columnMinWidth: {
      type: String
    },
    // 审批的其他参数
    FlowForm: {
      type: Object
    },
    // 不同业务模块api接口对应模块 doc
    module: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formItemLinkConfig: {
      }, // 表单元素联动配置对象
      formItemConfigList: []
    }
  },
  computed: {
    formItemList(ctx) {
      const filterList = cloneDeep(ctx.formConfig.formItemList)
      return filterList && filterList.length > 0 && filterList.filter(item => item['isShow'])
    }
  },
  watch: {
    // 获取默认值
    formConfig: {
      handler: function(newVal, oldVal) {
        if ('formItemList' in newVal && newVal['formItemList']) {
          this.setDefaultValue()
        }
      },
      deep: true,
      immediate: true
    },
    'formConfig.formItemList': {
      handler: function(newVal, oldVal) {
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs['ruleForm'].clearValidate()
    })
  },
  methods: {
    deepClone,
    // formChangeEvent,
    /**
     * @description: 修改值
     * @param {*} val
     * @param {*} row
     * @return {*}
     */
    handleInput(val, item) {
      const { key, type, keyName } = item
      this.$nextTick(() => {
        if (type === 'select' && keyName) {
          const keyNameValue = key + '_keyNameValue'
          this.$emit('input', { ...this.value, [keyName]: item[keyNameValue], [key]: val })
        } else {
          this.$emit('input', { ...this.value, [key]: type === 'input' ? val.trim() : val })
        }

        if (type === 'date' || type === 'time') {
          this.handleLinkChange(val, item)
        }
      })
    },
    /**
     * @description: 设置默认值
     * @param {*}
     * @return {*}
     */
    setDefaultValue() {
      const formData = { ...this.value }
      // 设置默认值
      if ('formItemList' in this.formConfig && this.formConfig['formItemList']) {
        this.formConfig['formItemList'] && this.formConfig['formItemList'].forEach(item => {
          const { key, value, disabledConfig } = item
          /**
           * 如果没有赋值 就默认展示
           * 赋值了 就用传入的
           */
          if (!('isShow' in item)) {
            item['isShow'] = true // 默认全部显示
          }
          this.$nextTick(() => {
            // 判断disabled 是否需要解析
            if (disabledConfig && (typeof disabledConfig === 'string') && disabledConfig.indexOf('this') >= 0) {
              item['disabled'] = Boolean(eval(disabledConfig))
            }
          })

          if (formData[key] === undefined || formData[key] === null) {
            formData[key] = value
          }
        })

        this.$emit('input', { ...formData })
      }
    },
    /**
     * @description: 附件上传返回值
     * @param {*} data
     * @return {*}
     */
    fileCallBack(data) {
      const { key, val } = data
      this.$emit('input', { ...this.value, [key]: val })
    },
    /**
     * @description: 附件上传列表返回值
     * @param {*}
     * @return {*}
     */
    fileListCallBack(data) {
      const { key, val } = data
      this.$emit('input', { ...this.value, [key]: val })
    },
    /**
     * @description: 代码编辑器返回值
     * @return {*}
     */
    excelTextCallBack(data) {
      const { key, val } = data
      this.$emit('input', { ...this.value, [key]: val })
    },
    /**
     * @description: 保存
     * @param {*} data
     * @param {*} eventsCallback 回调函数集合 successFn 成功回调
     * @return {*}
     */
    onSubmit(data, eventsCallback) {
      const { successFn, handleBeforeSubmit } = eventsCallback
      const { type, data: {
        detail_list = [],
        del_list = []
      }} = data
      // const delete_ids = this.delIds ? this.delIds : (del_list.length > 0 ? del_list.map(item => item.id).join(',') : '')
      /**
       *  在这里对新增删除没有id的做判空
       */
      // 方法1   const delete_ids = this.delIds ? this.delIds : (del_list.length > 0 ? del_list.flatMap(item => item.id ? [item.id] : '') : '')
      // 方法2：
      const delete_ids = this.delIds ? this.delIds : (del_list.length > 0 ? del_list.filter(item => item.id).map(item => item.id).toString() : '')
      const isSubmit = type === 'submit' // 是否是单纯保存
      const formInstance = this.$refs['ruleForm']
      formInstance.validate(valid => {
        if (valid) {
          isSubmit && this.$emit('openSubmitLoading') // 打开提交loading
          !isSubmit && this.$emit('openSubmitAndSaveLoading') // 打开提交并保存loading
          let formData = null
          const formItemKeyList = []
          const formValueFilterHidden =
          this.formConfig['formItemList'].reduce((pre, cur) => {
            formItemKeyList.push(cur['key'])
            if (cur['isShow']) {
              pre[cur['key']] = this.value[cur['key']]
            }
            return pre
          }, {})
          Object.keys(this.value).forEach(key => {
            if (!formItemKeyList.includes(key)) {
              formValueFilterHidden[key] = this.value[key]
            }
          })
          console.log('formValueFilterHidden', formValueFilterHidden)
          formData = {
            'DocModel': this.formConfig['DocModel'],
            'FormData': JSON.stringify({ ...formValueFilterHidden, ...{ detail_list, delete_ids }})
          }

          // 若其他参数为空则不传递
          Object.keys(this.FlowForm).length > 0 && this.$set(formData, 'FlowForm', this.FlowForm)
          const params = {
            module: this.module,
            params: { ...formData }
          }
          // 如果有在保存前做的提交可以在这里处理
          if (handleBeforeSubmit) {
            handleBeforeSubmit(this)
          }
          Apis[isSubmit ? 'SaveDocument' : 'SaveDocumentAndSubmitApproval']({ ...params }).then(res => {
            // this.$emit('submitCb') // 成功回调
            isSubmit && this.$emit('closeSubmitLoading') // 关闭提交loading
            !isSubmit && this.$emit('closeSubmitAndSaveLoading') // 关闭提交并保存loading
            if (+res.data.res_status_code === 0) {
              // this.$emit('submitSuccessCb', res.data, successFn)
              this.$emit('submitSuccessCb', res.data, successFn && successFn.bind(null, Object.assign({}, res.data), this))
              this.$message({
                type: 'success',
                message: '操作成功'
              })
            } else if (+res.data.res_status_code === 99099) {
              this.$emit('submitErrorCb', res.data) // 失败回调
            } else {
              this.$emit('submitErrorCb', res.data) // 失败回调
              this.$message({
                type: 'error',
                message: res.data.res_message
              })
            }
          }).catch(err => {
            console.log('低代码保存失败报错：', err.message)
            isSubmit && this.$emit('closeSubmitLoading') // 关闭提交loading
            !isSubmit && this.$emit('closeSubmitAndSaveLoading') // 关闭提交并保存loading
          })
        } else {
          return false
        }
      })
    },
    /**
     * @description: 处理表单元素联动
     * @param {*}
     * @return {*}
     */
    handleLinkChange(val, item) {
      const { key, type, keyName } = item
      if (type === 'select' && keyName) {
        const keyNameValue = key + '_keyNameValue'
        this.$emit('input', { ...this.value, [keyName]: item[keyNameValue], [key]: val })
      } else {
        this.$emit('input', { ...this.value, [key]: type === 'input' ? val.trim() : val })
      }
      this.$nextTick(() => {
        handleLinkChangeEvent({
          val,
          item,
          flag: 'form',
          formInstance: this.lowcodeFormInstance,
          formTableInstance: {},
          formConfig: Object.assign({}, this.formConfig),
          thisCp: this,
          formRefs: this.$refs['ruleForm']
        })
        const { formConfig: { formItemList }} = this
        this.$set(this.formConfig, 'formItemList', formItemList)
      })
    },
    /**
     * @description: 设置联动关联值
     * @param {*}
     * @param {*} curKey 当前元素的Key
     * @return {*}
     */
    handleSetLinkValue(setLinkValue, curKey) {
      for (const item of setLinkValue) {
      /**
       * type interfaceAcquire - 接口获取
       * type fixValue - 固定值
       * type formula - 公式
       * linkKey 关联key
       */
        const { type, linkKey } = item
        if (type === 'interfaceAcquire') {
          this.handlelinkValueInterface(item, curKey)
        }

        if (type === 'fixValue') {
          this.handlelinkValueFix(item, curKey)
        }

        if (type === 'formula') {
          this.handlelinkValueFormula(item, curKey)
        }
      }
    },
    /**
     * @description: 处理接口方式的联动赋值
     * @param setLinkValue {Object} 接口配置数据
     * @param curKey {String} 当前元素key
     * @return {*}
     */
    handlelinkValueInterface(setLinkValue, curKey) {
      this.$nextTick(() => {
        let { linkKey, apiMethod, apiUrl, apiParams, cb, key: itemkey } = setLinkValue
        const APIPARAMS = deepClone(apiParams)
        /**
       * 主键用curKey 由于可能会有多个地方使用联动的关联key
       * 会导致关联key 不唯一
       */
        if (!(curKey in this.formItemLinkConfig)) {
          this.formItemLinkConfig[curKey] = {}
        }

        for (const key in apiParams) {
        /**
         * 只记录第一次
         * 之后不做记录
         */
          if (!(key in this.formItemLinkConfig[curKey])) {
            this.formItemLinkConfig[curKey][key] = apiParams[key]
          }
          /**
         * 循环配置参数中的属性，转换配置的参数为真实的值
         */
          this.convertConfigvalToValue({ source: apiParams, result: APIPARAMS, key, val: this.formItemLinkConfig[curKey][key] })
        }

        const params = {
          url: apiUrl,
          method: apiMethod
        }
        if (!apiMethod || apiMethod === 'get' || apiMethod === 'Get') {
          params['data'] = {}
          params['params'] = apiParams
        } else {
          params['params'] = {}
          params['data'] = apiParams
        }

        request(
          params
        ).then((res) => {
        /**
         * NOTE: 有新情况需要拓展
         * 这里只要判断只要有点 就是有层级结构
         */
          if (linkKey.indexOf('.') < 0) {
            // 如果只有一个单独的key 默认将其挂载到data上去
            linkKey = 'data.' + linkKey
          }
          this.setLinkKeyValue(linkKey, res)
        }).catch((err) => {
          console.log('处理接口方式时报错，原因：', err)
        })
      })
    },
    /**
     * @description: 处理联动固定值赋值
     * @param linkKey {String} 关联key
     * @param curKey {String} 当前元素key
     * @param res {Object} 返回结果
     * @return {*}
     */
    handlelinkValueFix(setLinkValue, curKey) {
      const _this = this.lowcodeFormInstance
      /**
       * 1、除字符串之外的数字
       * 2、字符串值
       * 3、字符串需要转真实的取值
       */
      let { linkKey, value, type } = setLinkValue
      setLinkValue['valueConfig'] = value

      if (linkKey.indexOf('.') < 0) {
        // 如果只有一个单独的key 默认将其挂载到data上去
        linkKey = 'data.' + linkKey
      }
      const MAIN_KEY = linkKey.split('.')[0] // 主key
      const CHILD_KEY = linkKey.split('.')[1] // 子key

      const fixedValue = this.getFixLinkValue(setLinkValue, curKey) // 解析后的值或者 传入的固定的值
      if (linkKey.startsWith('data.')) {
        _this[CHILD_KEY] = fixedValue
        // this.$emit('input', { ...this.value, [CHILD_KEY]: fixedValue })
      } else {
        // 主key 子key 需要存在 且值得存在
        if (MAIN_KEY && CHILD_KEY && _this[MAIN_KEY]) {
          this.$set(_this[MAIN_KEY], CHILD_KEY, fixedValue)
          if (MAIN_KEY === 'formValue') {
            // this.$emit('input', { ...this.value, [CHILD_KEY]: fixedValue })
          }
        }
      }
    },
    /**
     * @description: 获取固定值模式下的值
     * @param value {String|Number} 表达式或者字符串 或者数字
     * @param curKey {String} 当前元素的Key
     * @return {*}
     */
    getFixLinkValue(setLinkValue, curKey) {
      const { linkKey, value, type, key: itemKey, valueConfig } = setLinkValue
      /**
       * 主键用itemkey 由于可能会有多个地方使用联动的关联key
       * 会导致关联key 不唯一
       */
      if (!(curKey in this.formItemLinkConfig)) {
        this.formItemLinkConfig[curKey] = {}
      }

      if (typeof valueConfig === 'string') {
        const isFixValue = valueConfig.startsWith('$this.') // 判断是否是固定值 有$this的 都是需要特殊处理
        if (!isFixValue) {
          return value
        } else {
          // val.replace('$this.', '$this.lowcodeFormInstance.') // 将this指向替换为当前的低代码表单实例
          const trueValue = eval(optionsChain(value.replace('$this.', '$this.lowcodeFormInstance.'))) // 从表单实例对象中取到对应的数据值
          return trueValue
        }
      } else {
        return value
      }
    },
    /**
     * @description: 处理联动公式赋值
     * @param {String} curKey
     * @return {*}
     */
    handlelinkValueFormula(setLinkValue, curKey) {
      const _this = this.lowcodeFormInstance
      /**
       * 1、除字符串之外的数字
       * 2、字符串值
       * 3、字符串需要转真实的取值
       * itemKey 当前元素的key 用来做配置唯一主键
       */
      let { linkKey, value, type, params = {}} = setLinkValue
      // setLinkValue['cpParams'] = deepClone(params)

      if (linkKey.indexOf('.') < 0) {
        // 如果只有一个单独的key 默认将其挂载到data上去
        linkKey = 'data.' + linkKey
      }
      const MAIN_KEY = linkKey.split('.')[0] // 主key
      const CHILD_KEY = linkKey.split('.')[1] // 子key
      const computeValue = this.getComputeValue(setLinkValue, curKey) // 解析公式计算后的值

      if (linkKey.startsWith('data.')) {
        _this[CHILD_KEY] = computeValue
      } else {
        // 主key 子key 需要存在 且值得存在
        if (MAIN_KEY && CHILD_KEY && _this[MAIN_KEY]) {
          this.$set(_this[MAIN_KEY], CHILD_KEY, computeValue)
        }
        this.$set(_this[MAIN_KEY], CHILD_KEY, computeValue)
      }
    },
    /**
     * [number_format 参数说明：]
     * @param  {[type]} number        [number：要格式化的数字]
     * @param  {[type]} decimals      [decimals：保留几位小数,默认2]
     * @param  {[type]} dec_point     [dec_point：小数点符号]
     * @param  {[type]} thousands_sep [thousands_sep：千分位符号]
     * @param  {[type]} roundtag      [roundtag:舍入参数，默认"round" 四舍五入, "ceil" 向上取,"floor"向下取]
     * @return {[type]}               [description]
     *
     */
    setNumberFormat(num, formatOptions) {
      if (formatOptions && Object.keys(formatOptions).length > 0) {
        const { decimals, dec_point, thousands_sep, roundtag } = formatOptions
        return number_format(num, decimals, dec_point, thousands_sep, roundtag)
      } else {
        return num
      }
    },
    /**
     * @description: 解析公式计算后的值
     * @param {*}
     * @param curKey {String} 当前元素key
     * @return {*}
     */
    getComputeValue(setLinkValue, curKey) {
      const { linkKey, calculateMethod, params = {}, key: itemKey } = setLinkValue
      const cpParams = Object.assign({}, params)
      /**
       * 公式和接口取值操作方式不同
       * 从表单元素中获取 如果表单元素中没有主键对应的配置就赋值
       * 有的话 直接取
       */
      // if (!(curKey in this.formItemLinkConfig)) {
      //   this.formItemLinkConfig[curKey] = Object.assign({}, params)
      // }
      // console.log('this.formItemLinkConfig[curKey]', this.formItemLinkConfig)
      // 将values解析转换
      cpParams['values'] = this.complieConfigValues(cpParams['values'], calculateMethod)
      const value = eval(linkMethods[calculateMethod](cpParams))
      return this.setNumberFormat(value, (cpParams['formatOptions'] || {}))
    },
    /**
     * @description: 设置表单元素禁用
     * @param {*}
     * @return {*}
     */
    handleSetLinkDisabled() {},
    /**
     * @description: 设置表单元素必填
     * @param {*}
     * @return {*}
     */
    handleSetLinkRequired() {},
    /**
     * @description: 设置表单元素隐藏
     * @param {*}
     * @return {*}
     */
    handleSetLinkHidden() {},
    /**
     * TODO:暂时还不需要考虑多个 有的时候拓展
     * @description:从数组中找到对应的对象
     * 目前针对 单个属性 过滤
     * @param arr {Array} 目标数据源
     * @param filterParams {Object} 过滤的字段和值
     * @return {Object} 过滤后的对象
     */
    getObjFromArray(arr, filterParams) {
      if (filterParams && filterParams.length > 0) {
        for (const key in filterParams) {
          return arr.filter(item => item[key] === filterParams[key])[0]
        }
      } else {
        return arr[0]
      }
    },

    /**
     * @description: 循环执行数组 设置接口关联值
     * @param {*}
     * @return {*}
     */
    setInterfaceLinkValue(item) {

    },
    /**
     * @description: 转换对象配置的参数值到真实的值
     * @param source {Object} 参数数据源
     * @param key {string} 数据源中修改的Key
     * @param val {string|number} 数据源中修改的val
     * @return {*}
     */
    convertConfigvalToValue(configVal) {
      this.$nextTick(() => {
        const { source, result, key, val } = configVal
        if (typeof val === 'string') {
          const isFixValue = val.startsWith('$this.') // 判断是否是固定值 有$this的 都是需要特殊处理
          if (!isFixValue) {
            result[key] = val // 数值string类型,固定值
          } else {
          // val.replace('$this.', '$this.lowcodeFormInstance.') // 将this指向替换为当前的低代码表单实例
            const trueValue = eval(optionsChain(val.replace('$this.', '$this.lowcodeFormInstance.'))) // 从表单实例对象中取到对应的数据值
            result[key] = trueValue
          }
        } else {
          result[key] = val // 数值number类型
        }
      })
    },
    /**
     * @description: 解析配置的values
     * 加法 values[0]+values[1]
     * 减法 values[0]-values[1]
     * 乘法 values[0]*values[1]
     * 除法 values[0]/values[1]
     * 如果 values中 values[0]为$this.list 证明是明细数据
     * @param {Array} values 数据源
     * @return {*}
     */
    complieConfigValues(values = [], calculateMethod) {
      let dataSets = []
      let placeNum = 0 // 数字占位符
      for (const val of values) {
        if (typeof val === 'number') {
          dataSets.push(Number(val)) // 数值number类型
        } else {
          if (!val) {
            /**
             * 加减遇到null undefined '' 赋值0
             * 乘除赋值1
             */
            if (calculateMethod === 'lowcodeAdd' || calculateMethod === 'lowcodeSubtract') {
              placeNum = 0
              dataSets.push(0)
            } else {
              placeNum = 1
              dataSets.push(1)
            }
          } else {
            // 在这里判断是明细数据汇总还是简单数据
            if (val.indexOf('$this.list') >= 0) {
              const valSplit = val.split('.')
              const key = valSplit[valSplit.length - 1]
              // 取到列表真实的数据
              const trueList = this.lowcodeFormInstance.list || []
              // 将取到key那一列值对应赋给 dataSets
              dataSets = [...dataSets, ...(trueList.map((item, index) => {
                if (index === 0 && !(key && key in item && item[key])) {
                  console.error('配置的字段:' + key + '不在列表中')
                }
                return (key && key in item && item[key]) || placeNum
              }))]
            } else {
              if (typeof val === 'string') {
                const isFixValue = val.startsWith('$this.') // 判断是否是固定值 有$this的 都是需要特殊处理
                if (!isFixValue) {
                  dataSets.push(Number(val)) // 数值string类型,固定值
                } else {
                  // 从表单实例对象中取到对应的数据值
                  const trueValue = eval(optionsChain(val.replace('$this.', '$this.lowcodeFormInstance.')))
                  dataSets.push(Number(trueValue))
                }
              } else {
                if (val === undefined) {
                  dataSets.push(0) // undefined
                } else {
                  dataSets.push(Number(val)) // 数值number类型
                }
              }
            }
          }
        }
      }
      return dataSets || []
    },
    /**
     * @description: 重置方法
     * @return {*}
     */
    resetFormFields() {
      this.$refs['ruleForm'].resetFields()
    }
  },
  render(h) {
    return h('el-form', {
      ref: 'ruleForm',
      attrs: {
        class: 'jj-dynamic-form',
        model: this.value
      },
      formConfig: this.formConfig
    }, [
      h('el-row',
        {
          'class': 'form-main-body-class'
        },
        [
          h('el-col', {}, [

          ])
        ])
    ])
  }
}
</script>
<style lang='scss' scoped>

</style>
